import getWithXHR from 'Common/utils/getWithXHR'

const url = '/api/v1/current_user'

// Endpoint returns a current user object, see
// /app/views/api/v1/users/current.json.jb
const getCurrentUser = () => getWithXHR(url)

export default getCurrentUser
